// extracted by mini-css-extract-plugin
module.exports = {"BusinessInformation":"BusinessInfo_BusinessInformation__3JMJG","Title":"BusinessInfo_Title__2LCqm"};